import React from 'react';
import { makeStyles } from '@material-ui/core';
import GalleryIcon from '../../../icons/Gallery.png';
import clsx from 'clsx';

const UploadTile = ({ onSelection, accept, multiple = false, width = 320, height = 360, hasError }) => {
    const classes = useStyles();

    const onChange = (e) => {
        e.persist();
        onSelection(e.target.files);
        e.target.value = '';
    };

    return (
        <div
            className={clsx(classes.uploadTile, classes.text, { [classes.hasError]: hasError })}
            style={{ width, height }}
        >
            <img src={GalleryIcon} alt="" />
            <p>
                Drag and drop files to upload or{' '}
                <label>
                    <strong>
                        <u>browse files</u>
                    </strong>
                    <input
                        type="file"
                        accept={accept}
                        className={classes.hiddenFileInput}
                        onChange={onChange}
                        multiple={multiple}
                    />
                </label>
            </p>
        </div>
    );
};

export default UploadTile;

const useStyles = makeStyles((theme) => ({
    text: {
        fontSize: 14,
        fontWeight: 400,
        fontFamily: 'Gotham SSm A',
        lineHeight: '14px',
        color: theme.palette.text.primary,
        margin: '5px 0',
    },
    uploadTile: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid #e7e8e9',
        padding: theme.spacing(6),

        textAlign: 'center',

        '& img': {
            margin: theme.spacing(3),
        },
        '& strong': {
            cursor: 'pointer',
        },
    },
    hiddenFileInput: {
        position: 'absolute',
        height: 1,
        width: 1,
        overflow: 'hidden',
        clip: 'rect(1px, 1px, 1px, 1px)',
    },
    hasError: {
        border: '1px solid red',
    },
}));
